export class FormatHelper {

    public StringToCNPJ(value: string): string {
        return this.format(value, '00.000.000/0000-00');
    }

    public StringToCPF(value: string): string {
        return this.format(value, '000.000.000-00');
    }

    public StringToCellphone(value: string): string {
        return this.format(value, '(00) 00000-0000');
    }

    public onlyNumbers(value: string): string {
        return value.replace(/\D/g, '');
    }

    private format(value, Mascara): string {
        if (!value) { return ''; }

        let boleanoMascara;
        const exp = /\-|\.|\/|\(|\)| /g;
        const campoSoNumeros = value.toString().replace(exp, '');

        let posicaoCampo = 0;
        let NovoValorCampo = '';
        let TamanhoMascara = campoSoNumeros.length;

        for (let i = 0; i <= TamanhoMascara; i++) {
            boleanoMascara = ((Mascara.charAt(i) === '-') || (Mascara.charAt(i) === '.')
                || (Mascara.charAt(i) === '/'));
            boleanoMascara = boleanoMascara || ((Mascara.charAt(i) === '(')
                || (Mascara.charAt(i) === ')') || (Mascara.charAt(i) === ' '));
            if (boleanoMascara) {
                NovoValorCampo += Mascara.charAt(i);
                TamanhoMascara++;
            } else {
                NovoValorCampo += campoSoNumeros.charAt(posicaoCampo);
                posicaoCampo++;
            }
        }
        return NovoValorCampo;
    }
}
